import React from 'react';
import Company from './Company/';

class Companies extends React.PureComponent {
  render() {
    const { companies } = this.props;
    return (
      companies.length > 0 && (
        <React.Fragment>
          <h3 className="heading heading--2">Компании</h3>
          <div className="spoilers">
            {companies.map(company => (
              <Company key={`key-${company.id}`} company={company} />
            ))}
          </div>
        </React.Fragment>
      )
    );
  }
}

export default Companies;
